import { firebase } from "@coworker/common/config/firebase";

export async function getFirebaseDownloadUrl(path: string) {
  const storage = firebase.storage().ref();
  const fileRef = storage.child(path);
  return fileRef.getDownloadURL();
}
